import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import React from "react";

const BestuursinfoModal = ({
  modal,
  toggle,
  children,
  handleSubmit,
  classes,
  headerColor,
  showFooterBtns = true,
  header1 = "Bestuursinformatie",
  header2 = "Schoolinformatie",
  content1,
  content2,
  ...props
}) => {
  return (
    <Modal isOpen={modal} toggle={toggle} className={classes} style={{ borderRadius: "40px" }}>
      {content1 && (
        <>
          <ModalHeader
            toggle={toggle}
            className={headerColor}
            style={{ borderBottom: "1px solid #dee2e6" }}
          >
            {header1}
          </ModalHeader>
          <ModalBody style={{ borderBottom: "1px solid #dee2e6", padding: 0 }}>
            <div style={{ padding: "24px"}}>
              {content1}
            </div>
          </ModalBody>
        </>
      )}
      {content2 && (
        <ModalBody style={{ borderBottom: "1px solid #dee2e6", padding: 0 }}>
          <ModalHeader
            toggle={content1 ? undefined : toggle}
            className={headerColor}
            style={{ borderBottom: "1px solid #dee2e6" }}
          >
            {header2}
          </ModalHeader>
          <div style={{ padding: "24px" }}>
            {content2}
          </div>
        </ModalBody>
      )}
      {children && <ModalBody style={{ padding: 0 }}>{children}</ModalBody>}
      <ModalFooter>
        {showFooterBtns && (
          <>
            <Button color="link" onClick={toggle} className="btn-color-style">
              Scherm sluiten
            </Button>
            <Button color="secondary" onClick={handleSubmit} className="btn-color-style">
              Toepassen
            </Button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default BestuursinfoModal;